__turbopack_context__.v({
  "cta-container": "non-catalog-pp-offer-module-scss-module__5Kr01G__cta-container",
  "learn-more-link": "non-catalog-pp-offer-module-scss-module__5Kr01G__learn-more-link",
  "sub-value-prop-text": "non-catalog-pp-offer-module-scss-module__5Kr01G__sub-value-prop-text",
  "value-prop-badge": "non-catalog-pp-offer-module-scss-module__5Kr01G__value-prop-badge",
  "value-prop-icon": "non-catalog-pp-offer-module-scss-module__5Kr01G__value-prop-icon",
  "value-prop-text": "non-catalog-pp-offer-module-scss-module__5Kr01G__value-prop-text",
});
